import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';
//import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { ListItemComponent } from 'src/app/shared/components/list-item/list-item.component';
import {
  Authorizations,
  AuthorizationType
} from 'src/app/shared/model/authorization.model';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { OrderService } from 'src/app/core/services/order.service';
import { User } from 'src/app/shared/model/user.model';
import { ApproversTypes } from 'src/app/shared/model/approversTypes.enum';
import { RequestStatus } from 'src/app/shared/model/requestStatus.enum';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { HandlePermissions } from 'src/app/shared/utils/permissions';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  standalone: true,
  selector: 'app-authorizations',
  templateUrl: './authorizations.component.html',
  styleUrls: ['./authorizations.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    I18NextModule,
    ListItemComponent,
    MatDialogModule,
    MatSelectModule
  ],
  providers: [{ provide: MatDialogRef, useValue: {} }]
})
export class AuthorizationsComponent implements OnInit, AfterViewInit {
  authorizations: any[] = [];
  updateAuthorizationsList?: Authorizations[];
  data = RequestStatus.PENDING_APPROVAL;
  allSelected = false;
  checkSelectAll = false;
  result: any = [];
  comments = '';
  dialogRef?: MatDialogRef<ConfirmModalComponent>;
  user!: User;
  dataPagination: any;
  pageIndex = 1;
  requestNumbers = [''];
  RequestStatus = RequestStatus;
  noRequest = false;
  status = '';
  controllerUserId: string | null = null;
  delegatedApproverUserId: string | null = null;
  authorizationEnum = AuthorizationType;
  authorizationType: string = AuthorizationType.REQUESTS;
  spinner = false;
  enableRedPlates!: boolean;
  loading = false;

  constructor(
    private navigationService: NavigationService,
    private orderService: OrderService,
    private storageService: StorageService,
    public dialog: MatDialog,
    private premissions: HandlePermissions,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
      this.checkDlaOrCnt(this.user.nis);
      this.status = RequestStatus.PENDING_APPROVAL;

      this.verifyAuthorizationType(this.authorizationEnum.REQUESTS);
    }
    this.enableRedPlates = this.premissions.getPermission('RED_PLATES_APPROVE');
    this.storageService.set('navigation', 'authorizations');
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('authorizations');
    }, 0);
  }

  checkDlaOrCnt(nis: string) {
    if (
      this.user.authorizer === ApproversTypes.DLA ||
      this.userService.isPec(this.user?.category)
    ) {
      this.delegatedApproverUserId = nis;
    }
    if (this.user.authorizer === ApproversTypes.CNT) {
      this.controllerUserId = nis;
    }
    if (this.user.authorizer === ApproversTypes.ALL) {
      this.controllerUserId = nis;
      this.delegatedApproverUserId = nis;
    }
  }
  changeRequestType(event: RequestStatus) {
    this.data = event;
    this.getAuthorizations(event);
  }

  selectAll(all: boolean) {
    this.allSelected = all;
    this.checkSelectAll = all;
  }

  updatedAllSelected(update: boolean) {
    this.allSelected = update;
    this.checkSelectAll = update;
  }

  updatePage(page: number) {
    this.pageIndex = page + 1;
    this.getAuthorizations(this.data);
  }

  getAuthorizations(type: string) {
    this.dataPagination = null;
    this.authorizations = [];
    this.noRequest = false;
    this.status = type;
    this.spinner = true;
    if (this.authorizationType === this.authorizationEnum.TRANSFERS) {
      if (this.status === RequestStatus.APPROVED) {
        this.status = RequestStatus.PENDING_APPROVAL;
      }
      this.orderService
        .getTransfersApprover(this.status, this.pageIndex)
        .subscribe({
          next: (res: any) => {
            this.spinner = false;
            this.setAuthorizationsTransfers(res);
          },
          error: () => {
            this.spinner = false;
            this.authorizations = [];
            this.noRequest = true;
          }
        });
    } else if (this.authorizationType === this.authorizationEnum.RED_PLATES) {
      this.orderService
        .getRequestApproveRedPlates(
          this.status,
          this.controllerUserId!,
          this.delegatedApproverUserId!,
          this.pageIndex
        )
        .subscribe({
          next: (res: any) => {
            this.spinner = false;
            this.setAuthorizationsRedPlates(res);
          },
          error: () => {
            this.spinner = false;
            this.authorizations = [];
            this.noRequest = true;
          }
        });
    } else {
      this.orderService
        .getRequestApprover(
          this.status,
          this.controllerUserId!,
          this.delegatedApproverUserId!,
          this.pageIndex
        )
        .subscribe({
          next: (res: any) => {
            this.setAuthorizations(res);
            this.spinner = false;
          },
          error: () => {
            this.spinner = false;
            this.authorizations = [];
            this.noRequest = true;
          }
        });
    }
  }

  handleAuthorizations(type: string) {
    this.updateAuthorizationsList = this.authorizations.filter(
      (authorization) => authorization.checked
    );
    this.dialog
      .open(ConfirmModalComponent, {
        data: {
          type: type,
          requestType: this.authorizationType,
          list: this.updateAuthorizationsList
        }
      })
      .afterClosed()
      .subscribe((resp) => {
        this.comments = resp.data;
        this.requestNumbers = resp.listRequests;
        this.submitInfo(type);
      });
  }

  submitInfo(type: string) {
    this.loading = true;
    if (this.authorizationType === this.authorizationEnum.RED_PLATES) {
      const controllerUserId: string | null = this.user.nis;

      this.orderService
        .approveRedPlates(
          this.requestNumbers,
          type === RequestStatus.APPROVED,
          controllerUserId!,
          this.comments
        )
        .subscribe({
          next: () => {
            this.loading = false;
            location.reload();
          },
          error: (err) => {
            this.loading = false;
            console.log(err);
          }
        });
    } else {
      this.orderService
        .approvedOrRejectedRequests(
          this.requestNumbers,
          type === RequestStatus.APPROVED,
          this.controllerUserId!,
          this.delegatedApproverUserId!,
          this.comments
        )
        .subscribe({
          next: () => {
            this.loading = false;
            location.reload();
          },
          error: (err) => {
            this.loading = false;
            console.log(err);
          }
        });
    }
  }

  verifyAuthorizationType(auth: string) {
    this.allSelected = false;
    this.checkSelectAll = false;
    this.pageIndex = 1;
    this.authorizationType = auth;
    this.getAuthorizations(this.status);
  }

  setAuthorizations(res: any) {
    this.dataPagination = res;
    this.authorizations =
      this.status === RequestStatus.APPROVED
        ? res.requests.map((request: any) => {
            return {
              ...request,
              requestStatus: RequestStatus.APPROVED
            };
          })
        : res.requests;
    this.noRequest = false;
  }

  setAuthorizationsRedPlates(res: any) {
    this.dataPagination = res;
    this.authorizations =
      this.status === RequestStatus.APPROVED
        ? res.requests.map((request: any) => {
            return {
              ...request,
              status: RequestStatus.APPROVED
            };
          })
        : res.requests;
    this.noRequest = false;
  }

  setAuthorizationsTransfers(res: any) {
    this.dataPagination = res;
    this.authorizations =
      this.status === RequestStatus.PENDING_APPROVAL
        ? res.requests.map((request: any) => {
            return {
              ...request,
              requestStatus: RequestStatus.PENDING_APPROVAL
            };
          })
        : res.requests;
    this.noRequest = false;
  }
}
